export default __webpack_public_path__ + "static/media/sidebarlogo.1ecfcf67.svg";